import { Button } from '@mui/material'
import { FC, useCallback, useState } from 'react'
import { InformationModal } from 'utoniq-ui'

import { useMessage, useTranslation } from '@/core'
import { captureError } from '@/core/errors'

import { Action } from './../'

type CancelChangePlanButtonProps = {
  type: string
  artistId: string
  cancellingChangeSubscription: boolean
  onCancelChangeSubscription: Action['onCancelChangeSubscription']
}

export const CancelChangePlanButton: FC<CancelChangePlanButtonProps> = ({
  type,
  artistId,
  cancellingChangeSubscription,
  onCancelChangeSubscription,
}) => {
  const { t } = useTranslation('membership')
  const { showError } = useMessage()
  const [openConfirm, setOpenConfirm] = useState<boolean>(false)

  const handleCancelChangeSubscription = useCallback(async () => {
    return onCancelChangeSubscription(artistId)
      .catch(e => {
        captureError(e, 'MembershipTemplate')
        showError(new Error(t('error')))
      })
      .finally(() => setOpenConfirm(false))
  }, [artistId, onCancelChangeSubscription, showError, t])

  if (type !== 'stripe') {
    return null
  }

  return (
    <>
      <Button
        size="large"
        variant="contained"
        color="inherit"
        sx={{
          width: 240,
          '&.MuiButtonBase-root:hover': { bgcolor: 'grey.50' },
          bgcolor: 'grey.50',
        }}
        onClick={() => setOpenConfirm(true)}
      >
        {t('cancelChangePlan')}
      </Button>

      <InformationModal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        title={t('confirm')}
        content={t('cancelChangeConfirmContent')}
        cancelText={t('cancel')}
        buttons={
          <Button
            size="large"
            sx={{ minWidth: 212 }}
            onClick={handleCancelChangeSubscription}
            loading={cancellingChangeSubscription}
            disabled={cancellingChangeSubscription}
          >
            {t('stopSubscription')}
          </Button>
        }
      />
    </>
  )
}
